import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';

const IconUseDesk = () => (
  <svg width="115" height="115" viewBox="0 0 115 115" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="115" height="115" rx="57.5" fill="#FFF59B" />
    <circle cx="57.5" cy="57.5" r="41.7773" fill="#292929" />
    <path
      d="M55.0379 62.1636C55.0379 59.4147 55.9152 57.894 59.0736 55.9639L62.115 54.0337C64.747 52.3961 66.3262 50.8169 66.3262 47.3076C66.3262 43.5643 63.7527 40.7569 58.6642 40.7569C53.2248 40.7569 50.3589 43.9738 49.4815 47.7755L45.1534 46.8982C46.2647 41.1078 50.4758 36.7212 58.6642 36.7212C66.7941 36.7212 70.9467 41.1663 70.9467 47.3076C70.9467 52.6885 67.9053 55.4375 65.2149 57.1336L62.5829 58.7713C59.8925 60.409 59.4245 61.3448 59.4245 63.7428V66.2578H55.0379V62.1636ZM54.453 77.0781V70.9369H60.1264V77.0781H54.453Z"
      fill="#FFF59B"
    />
  </svg>
);

export const Information = () => {
  const translations = useTranslations();

  return (
    <View>
      <Icon>
        <IconUseDesk />
      </Icon>
      <Content>
        <Title>{translations.t('site.home.assistance.information.title')}</Title>
        <Text>{translations.t('site.home.assistance.information.text')}</Text>
      </Content>
    </View>
  );
};

const View = styled.div`
  background-color: ${Colors.main_black};
  padding: 20px 40px 40px;
  border-radius: 20px;
  color: ${Colors.white};

  @media ${Points.tablet_landscape} {
    display: flex;
    padding: 40px 80px 40px 40px;
  }
`;
const Icon = styled.div`
  margin-bottom: 20px;

  svg {
    width: 70px;
    height: 70px;
    display: block;
  }

  @media ${Points.tablet_landscape} {
    margin-right: 40px;
    margin-bottom: 0;

    svg {
      width: 115px;
      height: 115px;
    }
  }
`;
const Content = styled.div``;
const Title = styled.div`
  font-size: 20px;
  line-height: 1.1;
  font-weight: 500;
  margin-bottom: 10px;

  @media ${Points.tablet_landscape} {
    margin-bottom: 15px;
  }

  @media ${Points.laptop_wide} {
    font-size: 24px;
    margin-bottom: 20px;
  }
`;
const Text = styled.div`
  font-size: 16px;
  line-height: 1.3;

  @media ${Points.laptop_wide} {
    font-size: 18px;
  }
`;
